import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import FileCard from '../FileCard'
import FolderCard from '../FolderCard'
import './FileGrid.scss'

const FileGrid = ({
  isFolder,
  folders,
  files,
  selectedItems,
  onSelectionChange,
  onAction,
  user,
  orgUserList,
  defaultQuery,
  userId,
  isSuperAdmin,
  isAdmin,
  aiProcessingItems,
  setVersionFile,
  setVersionModalVisible,
  setManagePermissionsModalVisible,
  setAuitModal,
  hoveredItemId,
  setHoveredItemId,
  shouldShowCheckbox,
  isAllFoldersSelected,
  isIndeterminateFolders,
  handleSelectAllFolders,
  isAllFilesSelected,
  isIndeterminateFiles,
  handleSelectAllFiles,
  searchType,
  isDownloadCenter
}) => {
  const { t } = useTranslation()

  return (
    <div>
      {/* Folders group */}
      {!searchType && isFolder && (
        <Fragment>
          <div className="group-label group-label-flex-gap">
            {selectedItems.length > 0 && (
              <input
                type="checkbox"
                checked={isAllFoldersSelected}
                ref={el => {
                  if (el) el.indeterminate = isIndeterminateFolders
                }}
                onChange={handleSelectAllFolders}
                className="group-checkbox"
              />
            )}
            <span>{t('v4:folders')}</span>
          </div>
          {folders.length > 0 ? (
            <div className="folders-row">
              {folders.map(item => (
                <FolderCard
                  key={item.id}
                  item={item}
                  selectedItems={selectedItems}
                  onSelectionChange={onSelectionChange}
                  onAction={onAction}
                  user={user}
                  orgUserList={orgUserList}
                  defaultQuery={defaultQuery}
                  userId={userId}
                  isSuperAdmin={isSuperAdmin}
                  isAdmin={isAdmin}
                  aiProcessingItems={aiProcessingItems}
                  setVersionFile={setVersionFile}
                  setVersionModalVisible={setVersionModalVisible}
                  setManagePermissionsModalVisible={
                    setManagePermissionsModalVisible
                  }
                  setAuitModal={setAuitModal}
                  hoveredItemId={hoveredItemId}
                  setHoveredItemId={setHoveredItemId}
                  shouldShowCheckbox={shouldShowCheckbox}
                />
              ))}
            </div>
          ) : (
            <div className="no-folders-found">
              <span className="anticon anticon-folder-open folder-open-icon" />
              <div>{t('v4:no_folders_found')}</div>
            </div>
          )}
        </Fragment>
      )}

      {/* Files group */}
      {files.length > 0 && !isFolder && (
        <>
          <div className="group-label group-label-flex-gap">
            {selectedItems.length > 0 && (
              <input
                type="checkbox"
                checked={isAllFilesSelected}
                ref={el => {
                  if (el) el.indeterminate = isIndeterminateFiles
                }}
                onChange={handleSelectAllFiles}
                className="group-checkbox"
              />
            )}
            <span>{t('v4:files')}</span>
          </div>
          {files.length > 0 ? (
            <div className="files-grid">
              {files.map(item => (
                <FileCard
                  key={item.id}
                  item={item}
                  selectedItems={selectedItems}
                  onSelectionChange={onSelectionChange}
                  onAction={onAction}
                  user={user}
                  orgUserList={orgUserList}
                  defaultQuery={defaultQuery}
                  userId={userId}
                  isSuperAdmin={isSuperAdmin}
                  isAdmin={isAdmin}
                  aiProcessingItems={aiProcessingItems}
                  setVersionFile={setVersionFile}
                  setVersionModalVisible={setVersionModalVisible}
                  setManagePermissionsModalVisible={
                    setManagePermissionsModalVisible
                  }
                  setAuitModal={setAuitModal}
                  hoveredItemId={hoveredItemId}
                  setHoveredItemId={setHoveredItemId}
                  shouldShowCheckbox={shouldShowCheckbox}
                  isDownloadCenter={isDownloadCenter}
                />
              ))}
            </div>
          ) : (
            <div className="no-files-found">
              <span className="anticon anticon-file file-icon" />
              <div>{t('v4:no_files_found')}</div>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default FileGrid
